import React from "react";
import {Cloud, Zap} from "lucide-react";

function SkyCartDevPage() {

    return <div id={'default'} className={''}>

        <section
            className="relative overflow-hidden pt-20 pb-16 lg:pt-32 lg:pb-24 bg-gradient-to-b from-blue-50/50 to-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <span
              className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800 mb-6">
            <Zap className="w-3.5 h-3.5 fill-current"/> Проста CRM для малого e-commerce
          </span>

                <div className="flex justify-center">
                    <div className="flex items-center space-x-2">
                        <div className="bg-blue-600 p-2 rounded-xl text-white">
                            <Cloud className="w-6 h-6" />
                        </div>
                        <h1 className="text-xl font-bold tracking-tight bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                            SkyCart<span className="text-slate-400 font-normal">.cloud</span>
                        </h1>
                    </div>
                </div>
                <p className="mt-6 text-lg sm:text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed">
                    Хмарна CRM-система нового покоління для оптимізації бізнес-процесів, збільшення продажів та
                    автоматизації рутини.
                </p>
                <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
                    <button
                        className="w-full sm:w-auto bg-white border border-slate-200 hover:bg-slate-50 text-slate-700 px-8 py-4 rounded-xl font-medium transition">
                        ⏳ Ми в процесі розробки...
                    </button>
                </div>
            </div>
        </section>
    </div>
}

export default SkyCartDevPage;
